// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"560c9385","455":"8e2ffd1e","977":"e4f00949"}[chunkId] + ".chunk.js";
};